import { L2RButton, styledForMobile } from "@l2r-front/l2r-ui"

const DESKTOP_SIZE = 37
const MOBILE_SIZE = 44

export const Button = styledForMobile(L2RButton)(({ isMobile, theme }) => ({
    "&.MuiIconButton-root": {
        width: isMobile ? MOBILE_SIZE : DESKTOP_SIZE,
        height: isMobile ? MOBILE_SIZE : DESKTOP_SIZE,
        boxShadow: theme.customShadow("LCS/Shadow-simple"),
    },
}))
